<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <div class="layout-container max-w-full">
        <B2BTopBar/>
        <main>
            <slot/>
        </main>
        <Footer/>
    </div>
    <OnlyMobile :maxSize="1024">
        <MobileMenu/>
        <MobileProfileMenu/>
        <MobileNav/>
    </OnlyMobile>
    <BaseCallback/>
    <OnlyDesktop :maxSize="1024">
        <SpeedDial/>
    </OnlyDesktop>
    <CookieAccept/>
    <Toast/>
</template>

<script>
import {Head, Link, router} from '@inertiajs/vue3';
import {onMounted} from "vue";
import TopBar from "@js/components/TopBar/TopBar.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import MobileNav from "@js/components/Mobile/MobileNav.vue";
import Toast from "@js/components/Toast/Toast.vue";
import Footer from "@js/components/Footer/Footer.vue";
import MobileMenu from "@js/components/Mobile/MobileMenu.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import {useMenuStore} from "@js/store/MenuStore.js";
import MobileSearchPopup from "@js/components/Search/MobileSearchPopup.vue";
import {useCartStore} from "@js/store/CartStore.js";
import MobileProfileMenu from "@js/components/Mobile/MobileProfileMenu.vue";
import ImageSearchPopup from "@js/components/Sections/ImageSearch/ImageSearchPopup.vue";
import ImageSearchResults from "@js/components/Sections/ImageSearch/ImageSearchResults.vue";
import SpeedDial from "@js/components/Widgets/SpeedDial.vue";
import {useJivoStore} from "@js/store/JivoStore.js";
import {checkDocument} from "@js/helpers.ts";
import CookieAccept from "@js/components/Widgets/CookieAccept.vue";
import BaseCallback from "@js/components/Callbacks/BaseCallback.vue";
import IconLogo from "@js/components/Icons/IconLogo.vue";
import B2BTopBar from "@js/Pages/B2B/B2BTopBar.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";

export default {
    name: "PartnershipLayout",
    components: {
        B2BTopBar,
        IconLogo,
        Link,
        BaseCallback,
        CookieAccept,
        SpeedDial,
        ImageSearchResults,
        ImageSearchPopup,
        MobileProfileMenu,
        MobileSearchPopup,
        OnlyDesktop,
        MobileMenu,
        Head,
        Footer,
        Toast,
        MobileNav,
        OnlyMobile,
        TopBar
    },
    props: {
        title: String,
        description: String,
        menuItems: {
            required: true,
        }
    },
    mounted() {
        router.on("before", (event) => {
            this.menuStore.closeSidenav()
            this.menuStore.closeProfileSidenav()
        })
    },
    methods: {},
    beforeUnmount() {
        if (!checkDocument()) {
            window.removeEventListener('jivo-message-received', this.jivoStore.jivoOnMessageReceived);
        }
    },
    setup(props) {
        const cartStore = useCartStore()
        const menuStore = useMenuStore()
        const jivoStore = useJivoStore()
        const themeStore = useThemeStore()

        // //Здесь делаем синхронизации с куки и localStorage
        onMounted(() => {
            cartStore.loadCart()

            if (!checkDocument()) {
                window.addEventListener('jivo-message-received', function () {
                    console.log(123)
                });
                window.addEventListener('jivo-message-received', jivoStore.jivoOnMessageReceived);
            }
        })

        menuStore.menuItems = props.menuItems
        themeStore.insertNavigationSchemaMarkup(props.menuItems)

        return {menuStore, cartStore, jivoStore}
    }
}
</script>

<style lang="scss" scoped>
.layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    main {
        flex: 1;
    }
}
</style>
